import useFeatureEligibility from '~/modules/featureControl/composables/useFeatureEligibility';
import { useProductType } from '~/composables/useProductType';
import { GIFT_CARD_TYPE } from '../constants/giftcard';

/**
 * * Gift Card Type Composable
 *
 * @description
 * Determines the type of gift card
 *
 * Possible values:
 * - 'basic' - Basic gift card
 * - 'egiftcard' - E-gift card
 * - 'consolidated_master' - Consolidated gift card
 */
export const useGiftCardType = (): GIFT_CARD_TYPE => {
  const { isConsolidatedMaster } = useProductType();
  const { isEGiftCard } = useFeatureEligibility();

  if (isConsolidatedMaster) {
    return GIFT_CARD_TYPE.CONSOLIDATED_MASTER;
  }

  if (isEGiftCard) {
    return GIFT_CARD_TYPE.E_GIFT_CARD;
  }

  return GIFT_CARD_TYPE.BASIC;
};
